var _ref;
import FunbankIconsConfig from "./config/svg-icons-config/app-icons/funbank";
import BancoGeneralIconsConfig from "./config/svg-icons-config/app-icons/banco-general";
import InterbankIconsConfig from "./config/svg-icons-config/app-icons/interbank";
const IconsMap = {
  'funbank': FunbankIconsConfig,
  'banco-general': BancoGeneralIconsConfig,
  'interbank': InterbankIconsConfig
};
const Icons = IconsMap[(_ref = process.env.NEXT_PUBLIC_APP_CONFIG) !== null && _ref !== void 0 ? _ref : 'funbank'];
export default Icons;